import React, { Component } from 'react';
import styled from 'styled-components';
import Modal from 'react-modal';
import { connect } from 'react-redux';
import { authInput, SignupUserNamePass, LoginUserNamePass } from '../store/actions';

Modal.defaultStyles.overlay.top = 160;
Modal.defaultStyles.overlay.backgroundColor = '';
Modal.defaultStyles.overlay.overflow = 'hidden auto';
Modal.setAppElement('#root');

const StyledModal = styled(Modal)`
  height: 100vh;
  background-color: black;
  border: none;
  outline: none;
  &:focused {
    outline: none;
  }
`;

class ModalComponent extends Component {
  constructor(props) {
    super(props);
    this.state = { isLoggedInFirstRender: false, modalIsOpen: false };
  }

  toggleModal = () => {
    this.setState({ modalIsOpen: !this.state.modalIsOpen });
  };

  render() {
    return <StyledModal isOpen={this.props.isOpen}>{this.props.children}</StyledModal>;
  }
}
const mapStateToProps = state => ({
  auth: state.auth,
});

export default connect(
  mapStateToProps,
  { authInput, SignupUserNamePass, LoginUserNamePass }
)(ModalComponent);



// WEBPACK FOOTER //
// ./src/components/Modal.js